import RankingRender from './RankingRender'
import NumberRender from './NumberRender'
import QuotesRender from './QuotesRender'

/**
 * Kiest de weergave op basis van het weergavecontract van het celtype.
 *
 * De frontend kent geen celtypes, alleen deze contracten — dat is wat "een
 * nieuw celtype is puur backend-werk" mogelijk maakt. Komt er een contract
 * langs dat hier niet bestaat, dan zegt de component dat expliciet in plaats
 * van niets te tonen: een leeg vlak leest als "geen resultaten".
 *
 * AI-CONTEXT: See docs/features/intelligence-research-questions.md (§3)
 *
 * @param {object} props
 * @param {string} props.render - het weergavecontract ('ranking' | 'number' | 'quotes')
 * @param {object} props.output - de uitvoer van het celtype
 */
const CellRender = ({ render, output }) => {
    if (!output) return <p className="intelligence-state">Nog geen uitkomst.</p>

    switch (render) {
        case 'ranking':
            return <RankingRender rows={output.rows} measurable={output.measurable} />
        case 'number':
            return (
                <NumberRender
                    value={output.value}
                    unit={output.unit}
                    n={output.n}
                    orgs={output.orgs}
                    measurable={output.measurable}
                />
            )
        case 'quotes':
            return <QuotesRender rows={output.rows} measurable={output.measurable} />
        default:
            return (
                <p className="intelligence-state intelligence-state--error">
                    Dit inzicht gebruikt weergavetype '{render}', dat deze versie van de app niet kent.
                </p>
            )
    }
}

export default CellRender
